import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    LinearProgress,
} from '@mui/material'
import { courseTopicApiSlice } from '../../../../../features/course/courseTopicSlice'
import {
    ActiveCourseTopicState,
    neighbourPositions,
} from '../../../../../features/types'
import DndCourseTopics from './DndCourseTopics'

interface Props {
    open: boolean
    topics: ActiveCourseTopicState[]
    handleClose: () => void
}

const styles = {
    dndBox: {
        //display: 'flex',
        maxHeight: '600px',
        overflow: 'auto',
        mb: 2,
    },
}

const ReorderCourseTopicsDialog: React.FC<Props> = ({
    open,
    topics,
    handleClose,
}) => {
    const { formatMessage } = useIntl()
    const [items, setItems] = useState<ActiveCourseTopicState[]>([])
    const [dragggedTopicIndex, setDraggedTopicIndex] = useState<number>(null)
    const [refreshCourseTopicsOrder, { isLoading }] =
        courseTopicApiSlice.useRefreshCourseTopicsOrderMutation()

    const save = async () => {
        const neighbourPositions = getNeighbourPositions()
        const selectedTopicId = items[dragggedTopicIndex].courseTopicId

        try {
            await refreshCourseTopicsOrder({
                neighbourPositions,
                id: selectedTopicId,
            }).unwrap()
            setDraggedTopicIndex(null)
            toast.success(formatMessage({ id: 'savedSuccess' }))
        } catch (error) {}
    }

    const getNeighbourPositions = (): neighbourPositions => {
        if (dragggedTopicIndex === 0) {
            return [0, items[1].position]
        } else if (dragggedTopicIndex === items.length - 1) {
            return [items[items.length - 2].position, null]
        } else {
            return [
                items[dragggedTopicIndex - 1].position,
                items[dragggedTopicIndex + 1].position,
            ]
        }
    }

    useEffect(() => {
        if (items.length && dragggedTopicIndex !== null) {
            save()
        }
    }, [items])

    useEffect(() => {
        if (topics) {
            setItems(topics)
        }
    }, [topics])

    return (
        <Dialog
            maxWidth={'md'}
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogTitle id="responsive-dialog-title">
                {formatMessage({ id: 'changeOrder' })}
            </DialogTitle>

            <DialogContent sx={styles.dndBox}>
                {isLoading && <LinearProgress sx={{ mb: 2 }} />}

                <DndCourseTopics
                    items={items}
                    setItems={(elements) => setItems(elements)}
                    setDraggedTopicIndex={setDraggedTopicIndex}
                />
            </DialogContent>

            {/* <DialogActions sx={{ m: 2 }}>
                <Button
                    disabled={isLoading}
                    onClick={handleClose}
                >
                    {formatMessage({ id: 'cancel' })}
                </Button>

                <Button
                    variant="contained"
                    disabled={isLoading}
                    onClick={() => save()}
                >
                    {isLoading ? (
                        <CircularProgress
                            size={20}
                            sx={{ mr: 1 }}
                        />
                    ) : (
                        formatMessage({ id: 'confirm' })
                    )}
                </Button>
            </DialogActions> */}
        </Dialog>
    )
}

export default ReorderCourseTopicsDialog
